import { type AxiosError } from 'axios'
import {
  type QueryFunctionContext,
  useQuery,
  type UseQueryOptions
} from 'react-query'

import useAuth from 'hooks/use-auth'
import { fetchQueryData } from 'hooks/use-gremlin-query'
import { awsMetadataQueryKeys } from 'queries/aws/query-keys'
import { getEndpointWithParams } from 'queries/queries-utils'

import type { AWSIAMRoleMetadata } from 'types/api/aws/metadata'

function fetchAwsIamRoleMetadata({
  queryKey
}: QueryFunctionContext<
  ReturnType<typeof awsMetadataQueryKeys.getIamRoleMetadata>
>) {
  return fetchQueryData<AWSIAMRoleMetadata>(getEndpointWithParams(...queryKey))
}

export function useGetAwsIamRoleMetadata(
  options?: Omit<
    UseQueryOptions<AWSIAMRoleMetadata, AxiosError>,
    'queryKey' | 'queryFn'
  >
) {
  const { currentTeamId } = useAuth()

  return useQuery({
    ...options,
    queryKey: awsMetadataQueryKeys.getIamRoleMetadata(currentTeamId),
    queryFn: fetchAwsIamRoleMetadata
  })
}
